import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-vista-previa-factura',
  templateUrl: './vista-previa-factura.component.html',
  styleUrls: ['./vista-previa-factura.component.scss']
})
export class VistaPreviaFacturaComponent implements OnInit {
  urlSafe: any;

  constructor(
    private dialogRef: MatDialogRef<VistaPreviaFacturaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    // console.log('Dialog', this.data)
    // const arr = new Uint8Array(data);
    // var file = new Blob([arr], { type: 'application/pdf' });
    // var fileURL = URL.createObjectURL(file);


    let blob = new Blob([this.data.src], {type: "application/pdf"});
    let url = URL.createObjectURL(blob);
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    // this.urlSafe += '#toolbar=0&navpanes=0';
  }

}
